module.exports = __webpack_public_path__ + "static/media/nTransactionsIcon.98e05815.svg";